import styles from './Textarea.module.scss'
import React from "react";
import Message from "../Message";
import {TextareaPropsInterface} from "./Textarea.props.interface";

const Textarea: React.FC<TextareaPropsInterface> = (
    {
        inputRef = null,
        label = '',
        size = 'medium',
        error = '',
        className = undefined,
        ...rest
    }) => {

    return (
        <label
            htmlFor={rest.id}
            className={[
                styles.container,
                error ? styles.error : null,
                styles[size],
                className,
            ].filter(Boolean).join(' ')}>

            {label}

            <textarea {...rest} ref={inputRef} value={rest.value || ''}/>

            {error ? <Message>{error}</Message> : null}
        </label>
    );
}

export default Textarea;
